import React, {Component} from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Actions
import {
    getCompanyScopesForSchemaYear,
    ESGScopeTypes
} from '../../../../actions/esg'

// Utils
import { translation } from '../../../../utils/helpers'

// Elements
import Panel from '../../../../shared/elements/panel'
import Col from '../../../../shared/elements/col'
import LabelWrapper from '../../../../shared/elements/labelWrapper'
import Label from '../../../../shared/elements/label'
import Row from '../../../../shared/elements/row'

import '../../Chain/View/index.scss'
import Categories from './categories'

class Scopes extends Component {
  constructor (props) {
    super(props)
    this.state = {
      scopes: []
    }
    this.cols = ['3fr', [2, 2], [6, 1]]
    this.maxDecimals = 3
  }

  componentDidMount () {
    this.getScopes(this.props.schemaId, this.props.year)
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.schemaId !== nextProps.schemaId || this.props.year !== nextProps.year) {
      this.getScopes(nextProps.schemaId, nextProps.year)
    }
  }

  getScopes (schemaId, year) {
    this.props.getCompanyScopesForSchemaYear(schemaId, year, ESGScopeTypes.Default).then((res) => {
      this.setState({ scopes: res.data })
    }, () => {
      window.toastr.error(translation('960'), translation('216'))
    })
  }

  render () {
    const renderScope = (scope, index) => {
      const applyScopeChange = (change) => {
        let scopes = [...this.state.scopes]
        scopes[index] = { ...scope, ...change }
        this.setState({ scopes: scopes })
      }

      return (
        <Row key={index}>
          <Col id='scope-col' key={index}>
            <Panel title={' '}>
              <LabelWrapper className='scope-title' labelText={scope.Title}>
                <Label>{scope.Description}</Label>
              </LabelWrapper>
            </Panel>
            <div className='category-container'>
              <Panel title={() => {}}>
                <Categories categories={scope.Categories} bubbleUpChange={applyScopeChange} />
              </Panel>
            </div>
          </Col>
        </Row>
      )
    }

    return (
      <div>
        {this.state.scopes.map(renderScope)}
      </div>
    )
  }
}

Scopes.propTypes = {
  schemaId: PropTypes.number.isRequired,
  year: PropTypes.number.isRequired
}

export default connect(null, {
  getCompanyScopesForSchemaYear
})(Scopes)



// WEBPACK FOOTER //
// ./src/app/pages/ESG/Company/Components/scopes.js